import React from "react";
import { Close, ErrorOutline } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import { config } from "../../../common/config";

const AlertMessage = (props) => {
  
  var fields ={
    variant:'filled',
    icon: <ErrorOutline sx={{fontSize:'2rem'}}/>,
    style:{fontSize:'1.5rem', display:'flex', alignItems:'center'},
    onClose:props.handleClose,
    sx:{width:'100%'},
    action:<Close onClick={props.handleClose} sx={{fontSize:'2rem'}}/>

  }
  if (props.open&&props.open!==null) {
    return(
      <div>
      <Snackbar open={props.open} autoHideDuration={config.alertMessageDuration} onClose={props.handleClose}>
          <Alert {...fields} severity={props.severity?props.severity:'success'}>
            {props.message}
          </Alert>
        </Snackbar>
      </div>
    )
  }
  else if(props.open!==null){
    return(
      <Snackbar open={!props.open} autoHideDuration={config.alertMessageDuration} onClose={props.handleClose}>
      <Alert {...fields} severity="error" >
        {props.message}
      </Alert>
    </Snackbar>
    )
  }
  else return <div className='d-none'></div>
};
export default AlertMessage;
